var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const context_1 = require("./context");
const themes = require('./.cache/themes');
exports.wrapRootElement = ({ element }) => {
    return (react_1.default.createElement(context_1.ThemeProvider, { themes: themes }, element));
};
//# sourceMappingURL=wrapRootElement.js.map